import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DrawResult,
  FullDetailedPaymentInfo,
  InstantWinGroup,
  InstantWins,
  PrizeDelivery,
  Raffle,
  RaffleCategory,
  RaffleSimple,
  SimpleRaffleAvailableGroup,
  SimpleRaffleGroup,
  TicketsCount,
  WinnerCms
} from '@core/models';
import { API_LIST } from '@core/services/web-api/api-list';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RaffleService {
  constructor(private httpClient: HttpClient) {}

  getSimpleRaffleGroupsInstantWin(
    slug: string
  ): Observable<SimpleRaffleAvailableGroup> {
    return this.httpClient.get<SimpleRaffleAvailableGroup>(
      API_LIST.getSimpleRaffleGroupsInstantWin(slug)
    );
  }

  getGameBySlug(
    slug: string,
    currency: string,
    cartId?: string,
    includeFinished?: boolean
  ): Observable<Raffle> {
    return this.httpClient.get<Raffle>(
      API_LIST.getGameBySlug(slug, currency, cartId, includeFinished)
    );
  }

  getPrizeDeliveryLinkDashboard(slug: string): Observable<PrizeDelivery> {
    return this.httpClient.get<PrizeDelivery>(
      API_LIST.getPrizeDeliveryLinkDashboard(slug)
    );
  }

  getPrizeDeliveryLink(
    orderId: string,
    queryKey: string
  ): Observable<PrizeDelivery> {
    return this.httpClient.get<PrizeDelivery>(
      API_LIST.getPrizeDeliveryLink(orderId, queryKey)
    );
  }

  getUserOrderDetailedPayment(
    orderId: string,
    queryKey: string = ''
  ): Observable<FullDetailedPaymentInfo> {
    return this.httpClient.get<FullDetailedPaymentInfo>(
      API_LIST.getUserOrderDetailedPayment(orderId, queryKey)
    );
  }

  getRaffleTicketGroups(
    raffleId: number,
    currency: string
  ): Observable<SimpleRaffleGroup> {
    return this.httpClient.get<SimpleRaffleGroup>(
      API_LIST.getRaffleTicketGroups(raffleId, currency)
    );
  }

  getUserGameTicketsCount(slug: string): Observable<TicketsCount> {
    return this.httpClient.get<TicketsCount>(
      API_LIST.getUserGameTicketsCount(slug)
    );
  }

  getRaffleResults(
    offset: number,
    limit: number,
    categories: string[] = [],
    rafflePage: boolean = false
  ): Observable<DrawResult[]> {
    return this.httpClient.get<DrawResult[]>(
      API_LIST.getRaffleResults(offset, limit, categories, rafflePage)
    );
  }

  getRaffleDraws(
    currency = 'GBP',
    categories = [],
    limit = 0,
    includeFinished = false,
    includeRunning = true,
    offset = 0,
    sortBy = '',
    filter = ''
  ): Observable<RaffleSimple[]> {
    return this.httpClient.get<RaffleSimple[]>(
      API_LIST.getRaffleDraws(
        currency,
        categories,
        limit,
        includeFinished,
        includeRunning,
        offset,
        sortBy,
        filter
      )
    );
  }

  getDrawWinners(offset: number, limit: number): Observable<WinnerCms[]> {
    return this.httpClient.get<WinnerCms[]>(
      API_LIST.getDrawWinners(offset, limit)
    );
  }

  getInstantWinTicketByGroupResponse(
    id: number,
    offset: number = 0,
    limit: number = 36
  ): Observable<HttpResponse<InstantWins[]>> {
    return this.httpClient.get<InstantWins[]>(
      API_LIST.getInstantWinTicketByGroup(id, offset, limit),
      { observe: 'response' }
    );
  }

  getInstantWinGroups(slug: string): Observable<InstantWinGroup[]> {
    return this.httpClient.get<InstantWinGroup[]>(
      API_LIST.getInstantWinGroupBySlug(slug)
    );
  }

  getCategories(): Observable<RaffleCategory[]> {
    return this.httpClient.get<RaffleCategory[]>(API_LIST.getCategories());
  }
}
